import * as React from "react";

export type CollabFilterChipProps = {
  active: boolean;
  count?: number;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
};

/** WordPlugin-style outline pill filter chip. */
export const CollabFilterChip: React.FC<CollabFilterChipProps> = ({
  active,
  count,
  onClick,
  children,
  className,
}) => (
  <button
    type="button"
    className={`collab-filter-chip${active ? " is-active" : ""}${className ? ` ${className}` : ""}`}
    onClick={onClick}
  >
    {children}
    {count !== undefined && count > 0 ? (
      <span className="collab-filter-chip__count">{count > 99 ? "99+" : count}</span>
    ) : null}
  </button>
);

export default CollabFilterChip;
